<template>
  <div :class="['form__checkbox-field', {'--open': isOpen}]">
    <button type="button" class="form__checkbox-top" @click.stop="isOpen = !isOpen">
      <span>{{ label }}</span>
      <Icon id="drop-arrow"/>
    </button>
    <DropDown :is-open="isOpen">
      <div class="form__checkbox-list">
        <div class="form__checkbox" v-for="option in options" :key="`${name}-${option.key}`">
          <input type="checkbox" :id="`${name}-${option.key}`" :name="`${name}[]`" :value="option.key"
                 :checked="modelValue.value?.includes(option.key)" @change="valueChange">
          <label :for="`${name}-${option.key}`">{{ option.value }}</label>
        </div>
      </div>
    </DropDown>
  </div>
</template>

<script>
import {FormFieldProps} from '@/components/form/fields/mixins'
import {DropDown, Icon} from '@/components/global'

export default {
  name: 'FormCheckbox',
  mixins: [FormFieldProps],
  components: {DropDown, Icon},
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    valueChange(event) {
        const newValue = this.modelValue.value.includes(event.target.value)
            ? Array.from(this.modelValue.value).toSpliced(this.modelValue.value.indexOf(event.target.value), 1)
            : Array.from(this.modelValue.value).concat([event.target.value])

      this.$emit('update:modelValue', {valid: this.required ? newValue.length >= 1 : true, value: newValue})
    }
  }
}
</script>